import { FunctionalComponent, h } from 'preact';
import { useTheme } from 'styled-components';

const SettingsIcon: FunctionalComponent = () => {
  const theme = useTheme();

  return (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M14.67 6.406l-1.075-.234a5.856 5.856 0 00-.347-.835l.596-.927a.418.418 0 00-.056-.522l-1.676-1.676a.418.418 0 00-.522-.056l-.927.596a5.856 5.856 0 00-.835-.347L9.594 1.33A.418.418 0 009.185 1h-2.37a.418.418 0 00-.41.33l-.233 1.075c-.286.094-.566.21-.835.347l-.927-.596a.418.418 0 00-.522.056L2.212 3.888a.418.418 0 00-.056.522l.596.927c-.137.27-.253.549-.347.835l-1.076.234A.418.418 0 001 6.815v2.37c0 .197.137.367.33.41l1.075.233c.094.286.21.566.347.835l-.596.927a.418.418 0 00.056.522l1.676 1.676c.14.139.357.162.522.056l.927-.596c.27.137.549.253.835.347l.234 1.076c.042.192.212.329.409.329h2.37a.418.418 0 00.41-.33l.233-1.075c.286-.094.566-.21.835-.347l.927.596a.418.418 0 00.522-.056l1.676-1.676a.418.418 0 00.056-.522l-.596-.927c.137-.27.253-.549.347-.835l1.076-.234A.418.418 0 0015 9.185v-2.37a.418.418 0 00-.33-.41zM10.51 8A2.513 2.513 0 018 10.51 2.513 2.513 0 015.49 8 2.513 2.513 0 018 5.49 2.513 2.513 0 0110.51 8z"
          fill={theme.ui.links.iconColor}
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export default SettingsIcon;
